import React, { createContext, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const AssociatedClientsContext = createContext();
export const ACTIONS = {
  SET_ERROR: "SET_ERROR",
  SET_IDLIST: "SET_IDLIST",
  SET_CURRENT_BALANCE: "SET_CURRENT_BALANCE",
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_FORM: "SET_FORM",
  SET_FORM_RESPONSE: "SET_FORM_RESPONSE",
  SET_DELETE_ID: "SET_DELETE_ID",
  SET_DELETE_RESPONSE: "SET_DELETE_RESPONSE",
};

const initialState = {
  errorFetch: null,
  idCliente: null,
  currentBalance: {},
  idList: null,
  form: null,
  formResponse: null,
  deleteId: null,
  deleteResponse: null,
};

const AssociatedClientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DELETE_RESPONSE: {
      return {
        ...state,
        deleteResponse: action.payload,
      };
    }
    case ACTIONS.SET_DELETE_ID: {
      return {
        ...state,
        deleteId: action.payload,
      };
    }
    case ACTIONS.SET_FORM_RESPONSE: {
      return {
        ...state,
        formResponse: action.payload,
      };
    }
    case ACTIONS.SET_FORM: {
      return {
        ...state,
        form: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorFetch: action.payload,
      };
    }
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idCliente: action.payload,
      };
    }
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_CURRENT_BALANCE: {
      return {
        ...state,
        currentBalance: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const AssociatedClientsContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(AssociatedClientsReducer, initialState);

  const { accessToken } = useContext(AccessTokenContext);

  React.useEffect(() => {
    if (state.deleteId) {
      LiferayService.deleteAccount(properties.base_url_api, state.deleteId)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_DELETE_RESPONSE,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error.message,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [state.deleteId]);

  React.useEffect(() => {
    if (state.form) {
      LiferayService.postAccount(properties.base_url_api, state.form)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_FORM_RESPONSE,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error.message,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [state.form]);

  React.useEffect(() => {
    if (state.idCliente) {
      LiferayService.getListaClientesAssociados(
        properties.base_url_api,
        state.idCliente,
        properties.codigo_empresa,
        properties.url_ws_empresa,
        ""
      )
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_CURRENT_BALANCE,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error.message,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [state.idCliente]);

  React.useEffect(() => {
    if (accessToken) {
      LiferayService.getIdList(properties.base_url_api)
        .then((response) => {
          dispatch({
            payload: response?.ok ? [] : response,
            type: ACTIONS.SET_IDLIST,
          });
          dispatch({
            payload: false,
            type: ACTIONS.SET_LOAD_PAGE,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [accessToken]);

  return (
    <AssociatedClientsContext.Provider value={[state, dispatch]}>
      {children}
    </AssociatedClientsContext.Provider>
  );
};
export default AssociatedClientsContextProvider;
